import { render } from "./testIndex.vue?vue&type=template&id=8a4377a2"
import script from "./testIndex.vue?vue&type=script&lang=js"
export * from "./testIndex.vue?vue&type=script&lang=js"

import exportComponent from "D:\\zhang\\项目\\经皮黄疸仪\\jaundiceweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__